import { render, staticRenderFns } from "./CourierForm.vue?vue&type=template&id=632ee6a0&scoped=true&"
import script from "./CourierForm.vue?vue&type=script&lang=js&"
export * from "./CourierForm.vue?vue&type=script&lang=js&"
import style0 from "./CourierForm.vue?vue&type=style&index=0&id=632ee6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ee6a0",
  null
  
)

export default component.exports